import { ethers } from 'ethers';

export const apiUrl = process.env.REACT_APP_API_URL;
export const worldIdApiUrl =process.env.REACT_APP_API_URL;
  // 'https://express-3buuw9tqr-azanadnan23s-projects.vercel.app';
  // 'https://express-gfxbzww25-azanadnan23s-projects.vercel.app';
  // 'https://express-2tnmqerw3-azanadnan23s-projects.vercel.app';
  // 'https://kpmg-api-dev2.kresus.com/';
export const easContractAddress = process.env.REACT_APP_EAS_CONTRACT_ADDRESS;
export const easUId = process.env.REACT_APP_EAS_UID;
export const magicRPC = process.env.REACT_APP_MAGIC_RPC;
export const chainID = process.env.REACT_APP_MAGIC_CHAIN_ID;
export const privateKey = process.env.REACT_APP_PRIVATE_KEY;
export const authKey = process.env.REACT_APP_AUTH_KEY;
export const easAttestationURL = process.env.REACT_APP_EAS_ATTESTATION_URL;

// Derive admin public key (wallet address) from private key
export const adminPublicKey = privateKey ? new ethers.Wallet(privateKey).address : undefined;
